import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import 'es6-promise/auto';

const Login = require('../login/login.vue.html');
const PortalHome = require('../portalhome/portalhome.vue.html');
const DocketingLanding = require('../portalhome/docketing/index.vue.html');
const DocketingDashboard = require('../portalhome/docketing/pages/dashboard/dashboard.vue.html');
const HearingDetails = require('../portalhome/docketing/pages/hearingdetails/hearingdetails.vue.html');
const ClaimsManagementDashboard = require('../portalhome/claimsmanagement/index.vue.html');

Vue.use(Router);

let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login', name: 'Login', component: Login, meta: {
                requiresAuth: false
            }
        },
        {
            path: '/', name: 'Portal', component: PortalHome, meta: {
                requiresAuth: true
            },
            children: [
                {
                    path: '/docketing/', component: DocketingLanding, meta: {
                        requiresAuth: true
                    },
                    children: [
                        {
                            path: '/', name: 'Dashboard', component: DocketingDashboard, meta: {
                                requiresAuth: true
                            }
                        },
                        {
                            path: '/docketing/hearingdetails/:id', name: 'HearingDetails', component: HearingDetails, props: (route) => ({ id: parseInt(route.params.id, 10) }), meta: {
                                requiresAuth: true
                            }
                        }
                    ]
                },
                {
                    path: '/claimsmanagement', name: 'ClaimsManagement', component: ClaimsManagementDashboard, meta: {
                        requiresAuth: true
                    }
                }

            ]
        }]
});

router.beforeEach((to, from, next) => {
    if (to.matched.length == 0) {
        next('/login');
    }

    const requiresAuth = to.matched.some(record =>
        record.meta.requiresAuth);

    const isAuthd = store.getters.isAuthenticated;

    if (to.fullPath == "/")
        store.dispatch('setApplicationName', '');

    if (requiresAuth && !isAuthd) {
        next('/login');
    }
    else if (requiresAuth && isAuthd) {
        //need to further verify they have access to the application they are requesting
        //TODO: SC need to implement this in a way that disallows user access 
        //to applications they don't have access to. FULLPATH is not the way


        //store.dispatch('validateAccess', to.fullPath).then((resp) => {
        //    if (resp)
        //        next();
        //    else {
        //        alert('you do not have access to the requested resource');
        //        next(false);
        //    }
        //});
        next();
    }
    else {
        next();
    }
});

router.afterEach((to, from) => {
    //console.log(store.getters.isAuthenticated);
})

export default router


// WEBPACK FOOTER //
// ./ClientApp/src/router/index.ts